import { QueryClient } from '@tanstack/react-query';

// One runtime client for the SPA. Auth boundaries clear this exact instance;
// components must not keep data from the previous operator for staleTime.
export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});
